define('lq/events/actions/scheduledTaskCommand',['lq/events/actions/eventAction'],
    function (EventAction) {
	    'use strict';

        function ScheduledTaskCommand(eventData, eventArg) {
	        EventAction.call(this, eventData, eventArg);
	        return this;
	    }

        EventAction.extend(ScheduledTaskCommand, EventAction);

        ScheduledTaskCommand.typeName = 'ScheduledTaskCommand';

	    ScheduledTaskCommand.prototype.getBatchType = function () {
            return EventAction.COMMAND_BATCH;
        };

	    ScheduledTaskCommand.prototype.createEventActionRequest = function () {
            var self = this;
	        
            return {
                eventActionType: "ScheduledTask",
                ObjectName: self.eventData.command
            };
        };

	    return ScheduledTaskCommand;
    }
);
